module.exports = __webpack_public_path__ + "static/media/inf_25og26.0d407165.mp3";